let readMore = document.getElementById('product-description-read-more');
let readLess = document.getElementById('product-description-read-less');
let productDescriptionContainer = document.getElementById('product-description');
let productDescriptionElements = productDescriptionContainer.querySelectorAll("p,ul,strong");

for (var i=0; i<productDescriptionElements.length; i++) {
  if (i>0) productDescriptionElements[i].style.display = "none";
}
readMore.style.display="block";

readMore.addEventListener('click', function readMoreFcn(event) {
  event.preventDefault();
  for (var i=0; i<productDescriptionElements.length; i++) {
    productDescriptionElements[i].style.display = "block";
  }
  readMore.style.display = "none";
  readLess.style.display = "block";
}, false);

readLess.addEventListener('click', function readLessFcn(event) {
  event.preventDefault();
  for (var i=0; i<productDescriptionElements.length; i++) {
    if (i>0) productDescriptionElements[i].style.display = "none";
  }
  readMore.style.display = "block";
  readLess.style.display = "none";
}, false);